import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW9101Model } from './kymw9101.model';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW9101InputModel } from './vo/kymw9101-input.model';
import { KYMW9101OutputModel } from './vo/kymw9101-output.model';
import { RadioLabelComponent } from '../../../commons/kymw02/radio-label/radio-label.component';
import { OrderCodeTextInputComponent } from '../../../commons/kymw02/text-input/order-code-text-input/order-code-text-input.component';
import { WjInputDate } from '@grapecity/wijmo.angular2.input';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * ログ検索条件画面を管理するクラス
 *
 * @export KYMW9101Component
 * @class KYMW9101Component
 */
@Component({
  selector: 'app-kymw9101',
  templateUrl: 'kymw9101.component.html',
  styleUrls: ['kymw9101.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW9101Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw9101Model: KYMW9101Model = new KYMW9101Model();
  private inputVO: KYMW9101InputModel;

  getKYMW9101Parameter: Function;

  @ViewChild('rbtn_goodsMaster', { static: true }) rbtn_goodsMaster: RadioLabelComponent;
  @ViewChild('txti_orderCode', { static: true }) txti_orderCode: OrderCodeTextInputComponent;
  @ViewChild('rbtn_planMaster', { static: true }) rbtn_planMaster: RadioLabelComponent;
  @ViewChild('rbtn_nonSpec', { static: true }) rbtn_nonSpec: RadioLabelComponent;
  @ViewChild('txti_pcode', { static: true }) txti_pcode: ElementRef;
  @ViewChild('txti_itemCode', { static: true }) txti_itemCode: ElementRef;
  @ViewChild('txti_userID', { static: true }) txti_userID: ElementRef;
  @ViewChild('chk_selectDuration', { static: true }) chk_selectDuration: ElementRef;
  @ViewChild('dtf_updateDateFrom', { static: true }) dtf_updateDateFrom: WjInputDate;
  @ViewChild('dtf_updateDateTo', { static: true }) dtf_updateDateTo: WjInputDate;
  @ViewChild('txi_DelivCatalogId', { static: true }) txi_DelivCatalogId: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  today: Date = new Date();


  /**
   * Creates an instance of KYMW9101Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @param {ElementRef} elementRef
   * @memberof KYMW9101Component
   */
  constructor(
    private dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW9101Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW9101';
    this.today = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate(), 13, 30);
    this.kymw9101Model.kymw9101Component = this;
    this.initKYMW9101();
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW9101Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVO = <KYMW9101InputModel>param;
    this.kymw9101Model.coopChibaCode = this.inputVO.coopChibaCode;
    this.kymw9101Model.coopGunmaCode = this.inputVO.coopGunmaCode;
    this.kymw9101Model.coopIbarakiCode = this.inputVO.coopIbarakiCode;
    this.kymw9101Model.coopNaganoCode = this.inputVO.coopNaganoCode;
    this.kymw9101Model.coopNiigataCode = this.inputVO.coopNiigataCode;
    this.kymw9101Model.coopSaitamaCode = this.inputVO.coopSaitamaCode;
    this.kymw9101Model.coopTochigiCode = this.inputVO.coopTochigiCode;
    this.kymw9101Model.coopTokyoCode = this.inputVO.coopTokyoCode;
    this.kymw9101Model.coopKurucoCode = this.inputVO.coopKurucoCode;
    this.kymw9101Model.itemCode = this.inputVO.itemCode;
    this.kymw9101Model.orderCode = this.inputVO.orderCode;
    this.kymw9101Model.pcode = this.inputVO.pcode;
    this.kymw9101Model.searchTableCondition = this.inputVO.searchTableCondition;
    this.kymw9101Model.selectDuration = this.inputVO.selectDuration;
    this.kymw9101Model.updateDateFrom = this.inputVO.updateDateFrom;
    this.kymw9101Model.updateDateTo = this.inputVO.updateDateTo;
    this.kymw9101Model.userID = this.inputVO.userID;
  }

  /**
   * 初期化処理
   *
   * @memberof KYMW9101Component
   */
  public initKYMW9101(): void {
    if (this.inputVO !== null) {
      // ①「ログ検索」画面から渡された検索条件が存在する場合、
      // 「ログ検索条件」画面で各条件を表示する。
      switch (this.inputVO.searchTableCondition) {
        case 1:
          this.kymw9101Model.radioGroup = '1';
          this.kymw9101Model.orderCodeDisabled = true;
          break;
        case 2:
          this.kymw9101Model.radioGroup = '2';
          this.kymw9101Model.orderCodeDisabled = false;
          break;
        case 3:
        default:
          this.kymw9101Model.radioGroup = '3';
          this.kymw9101Model.orderCodeDisabled = true;
          break;
      }
      this.kymw9101Model.orderCode = this.inputVO.orderCode;

      this.kymw9101Model.ibaraki = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopIbarakiCode)) ? true : false;
      this.kymw9101Model.tochigi = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopTochigiCode)) ? true : false;
      this.kymw9101Model.gunma = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopGunmaCode)) ? true : false;
      this.kymw9101Model.chiba = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopChibaCode)) ? true : false;
      this.kymw9101Model.saitama = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopSaitamaCode)) ? true : false;
      this.kymw9101Model.tokyo = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopTokyoCode)) ? true : false;
      this.kymw9101Model.nagano = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopNaganoCode)) ? true : false;
      this.kymw9101Model.niigata = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopNiigataCode)) ? true : false;
      this.kymw9101Model.kuruco = (!PlessViewUtilsSub.isEmpty(this.inputVO.coopKurucoCode)) ? true : false;
      this.kymw9101Model.pcode = this.inputVO.pcode;
      this.kymw9101Model.itemCode = this.inputVO.itemCode;
      this.kymw9101Model.userID = this.inputVO.userID;
      this.kymw9101Model.selectDuration = this.inputVO.selectDuration;
      if (this.kymw9101Model.selectDuration) {
        this.kymw9101Model.selectDuration = true;
        this.dtf_updateDateFrom.isDisabled = false;
        this.dtf_updateDateTo.isDisabled = false;
      } else {
        this.kymw9101Model.selectDuration = false;
        this.dtf_updateDateFrom.isDisabled = true;
        this.dtf_updateDateTo.isDisabled = true;
      }

      if (this.inputVO.updateDateFrom !== null && this.inputVO.updateDateFrom.length === 8) {
        this.kymw9101Model.updateDateFrom = PlessViewUtilsSub.editDate(this.inputVO.updateDateFrom, '2');
      } else {
        this.kymw9101Model.updateDateFrom = null;
      }
      if (this.inputVO.updateDateTo !== null && this.inputVO.updateDateTo.length === 8) {
        this.kymw9101Model.updateDateTo = PlessViewUtilsSub.editDate(this.inputVO.updateDateTo, '2');
      } else {
        this.kymw9101Model.updateDateTo = null;
      }
    } else {
      // ②「ログ検索」画面から渡された検索条件が存在しない場合、
      // マスタ選択を「指定しない」にする。
      // 会員生協の全ての項目をチェックする。
      // 受注コード、配達企画回(翌週)、Pコード、アイテムコード、ユーザーIDをクリアする。
      // 期間指定をOFFにして、「更新日(From)」「更新日(To)」を使用できないようにする。
      this.kymw9101Model.radioGroup = '3';
      this.kymw9101Model.orderCodeDisabled = true;
      this.kymw9101Model.ibaraki = true;
      this.kymw9101Model.tochigi = true;
      this.kymw9101Model.gunma = true;
      this.kymw9101Model.chiba = true;
      this.kymw9101Model.saitama = true;
      this.kymw9101Model.tokyo = true;
      this.kymw9101Model.nagano = true;
      this.kymw9101Model.niigata = true;
      this.kymw9101Model.kuruco = true;
      this.kymw9101Model.orderCode = '';
      this.kymw9101Model.pcode = '';
      this.kymw9101Model.itemCode = '';
      this.kymw9101Model.userID = '';
      this.kymw9101Model.selectDuration = false;
      this.dtf_updateDateFrom.isDisabled = true;
      this.kymw9101Model.updateDateFrom = null;
      this.dtf_updateDateTo.isDisabled = true;
      this.kymw9101Model.updateDateTo = null;
    }
    this.setFocus();
  }

  /**
   * ラジオボタン変更時処理
   *
   * @memberof KYMW9101Component
   */
  public rbtnChanged(): void {
    if (this.kymw9101Model.radioGroup === '1') {
      // 「受注コード」を使用できないようにする。
      this.kymw9101Model.orderCodeDisabled = true;
      this.txti_orderCode.setOrderCode(null);

      this.rbtn_goodsMaster.setFocus();
    } else if (this.kymw9101Model.radioGroup === '2') {
      // 「受注コード」を使用できるようにする。
      this.kymw9101Model.orderCodeDisabled = false;
    } else if (this.kymw9101Model.radioGroup === '3') {
      // 「受注コード」を使用できないようにする。
      this.kymw9101Model.orderCodeDisabled = true;
      this.txti_orderCode.setOrderCode(null);

      this.rbtn_goodsMaster.setFocus();
    }
  }

  /**
   * 期間指定チェックボックス変更時
   *
   * @param {Event} event
   * @memberof KYMW9101Component
   */
  public chkSelectDurationChanged(event: Event): void {
    if (this.kymw9101Model.selectDuration) {
      // 「更新日(From)」「更新日(To)」を使用できるようにする。
      this.dtf_updateDateFrom.isDisabled = false;
      this.dtf_updateDateTo.isDisabled = false;
      this.dtf_updateDateFrom.hostElement.tabIndex = 0;
      this.dtf_updateDateTo.hostElement.tabIndex = 0;
    } else {
      // 「更新日(From)」「更新日(To)」を使用できないようにする。
      this.dtf_updateDateFrom.isDisabled = true;
      this.dtf_updateDateTo.isDisabled = true;
      // 「更新日(From)」「更新日(To)」の値のクリア
      this.kymw9101Model.updateDateFrom = null;
      this.kymw9101Model.updateDateTo = null;
    }
  }

  /**
   * 「検索」ボタン押下時
   *
   * @param {MouseEvent} event
   * @returns {void}
   * @memberof KYMW9101Component
   */
  public searchBtnClicked(event: MouseEvent): void {
    // 「企画マスタ」を選択した場合、
    // 受注コードが空白ではない状態で配達企画回(翌週)が空白で表示されているとエラー表示。
    //   (メッセージID：E0113、%1：''入力した受注コード'')'
    if (this.kymw9101Model.radioGroup === '2') {
      if (PlessViewUtilsSub.isEmpty(this.kymw9101Model.orderCode)) {
        this.dialogService.openAlertGetMessage('W0001', ['受注コード']);
        return;
      }

      if (!this.txti_orderCode.isValidOrderCode()) {
        this.dialogService.openAlertGetMessage('E0113', ['入力した受注コード']);
        return;
      }
    }

    // 「期間指定」がチェックされている場合、更新日(from)の必須チェック
    if (this.kymw9101Model.selectDuration && PlessViewUtilsSub.isEmpty(this.kymw9101Model.updateDateFrom)) {
      this.dialogService.openAlertGetMessage('W0001', ['更新日(From)']);
      return;
    }

    // 「期間指定」がチェックされている場合、更新日(to)の必須チェック
    if (this.kymw9101Model.selectDuration && PlessViewUtilsSub.isEmpty(this.kymw9101Model.updateDateTo)) {
      this.dialogService.openAlertGetMessage('W0001', ['更新日(To)']);
      return;
    }

    // 「期間指定」がチェックされている場合、有効ではない更新日(FromがToより未来)の場合はエラー表示。
    // (メッセージID：E0123、%1：'更新日')
    if (this.kymw9101Model.updateDateFrom > this.kymw9101Model.updateDateTo) {
      this.dialogService.openAlertGetMessage('E0123', ['更新日']);
      return;
    }

    const outputVO: KYMW9101OutputModel = new KYMW9101OutputModel();
    outputVO.coopChibaCode = (this.kymw9101Model.chiba) ? this.kymw00Model.COOP_CODE_TI : '';
    outputVO.coopGunmaCode = (this.kymw9101Model.gunma) ? this.kymw00Model.COOP_CODE_GU : '';
    outputVO.coopIbarakiCode = (this.kymw9101Model.ibaraki) ? this.kymw00Model.COOP_CODE_IB : '';
    outputVO.coopNaganoCode = (this.kymw9101Model.nagano) ? this.kymw00Model.COOP_CODE_NA : '';
    outputVO.coopNiigataCode = (this.kymw9101Model.niigata) ? this.kymw00Model.COOP_CODE_NI : '';
    outputVO.coopSaitamaCode = (this.kymw9101Model.saitama) ? this.kymw00Model.COOP_CODE_SA : '';
    outputVO.coopTochigiCode = (this.kymw9101Model.tochigi) ? this.kymw00Model.COOP_CODE_TO : '';
    outputVO.coopTokyoCode = (this.kymw9101Model.tokyo) ? this.kymw00Model.COOP_CODE_TK : '';
    outputVO.coopKurucoCode = (this.kymw9101Model.kuruco) ? this.kymw00Model.COOP_CODE_KU : '';
    outputVO.itemCode = this.kymw9101Model.itemCode;
    if (this.kymw9101Model.radioGroup === '2') {
      outputVO.orderCode = this.kymw9101Model.orderCode;
      outputVO.catalogID = this.txti_orderCode.selectedCatalogID;
    }
    outputVO.pcode = this.kymw9101Model.pcode;
    if (this.kymw9101Model.radioGroup === '1') {
      outputVO.searchTableCondition = 1;
    } else if (this.kymw9101Model.radioGroup === '2') {
      outputVO.searchTableCondition = 2;
    } else if (this.kymw9101Model.radioGroup === '3') {
      outputVO.searchTableCondition = 3;
    }
    outputVO.selectDuration = this.kymw9101Model.selectDuration;
    if (this.kymw9101Model.selectDuration) {
      outputVO.updateDateFrom = PlessViewUtilsSub.editDate(this.kymw9101Model.updateDateFrom, '1');
      outputVO.updateDateTo = PlessViewUtilsSub.editDate(this.kymw9101Model.updateDateTo, '1');
    }
    outputVO.userID = this.kymw9101Model.userID;

    this.getKYMW9101Parameter(outputVO);

    // 『ログ検索条件』画面を終了する。
    this.closeFunction();
  }

  /**
   * クリアボタンクリック
   *
   * @param {MouseEvent} event
   * @memberof KYMW9101Component
   */
  public clearBtnClicked(event: MouseEvent): void {
    // 初期値に戻す。
    this.kymw9101Model.radioGroup = '3';
    this.kymw9101Model.orderCodeDisabled = true;
    this.kymw9101Model.ibaraki = true;
    this.kymw9101Model.tochigi = true;
    this.kymw9101Model.gunma = true;
    this.kymw9101Model.chiba = true;
    this.kymw9101Model.saitama = true;
    this.kymw9101Model.tokyo = true;
    this.kymw9101Model.nagano = true;
    this.kymw9101Model.niigata = true;
    this.kymw9101Model.kuruco = true;
    this.txti_orderCode.setOrderCode(null);
    this.kymw9101Model.pcode = '';
    this.kymw9101Model.itemCode = '';
    this.kymw9101Model.userID = '';
    this.kymw9101Model.selectDuration = false;
    this.dtf_updateDateFrom.isDisabled = true;
    this.dtf_updateDateTo.isDisabled = true;
    this.kymw9101Model.updateDateFrom = '';
    this.kymw9101Model.updateDateTo = '';
  }

  /**
   * フォーカス設定
   *
   * @private
   * @memberof KYMW9101Component
   */
  private setFocus(): void {
    if (this.kymw9101Model.radioGroup === '1') {
      this.rbtn_goodsMaster.setFocus();
    } else if (this.kymw9101Model.radioGroup === '2') {
      this.rbtn_planMaster.setFocus();
    } else {
      this.rbtn_nonSpec.setFocus();
    }
  }

}
